import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { debounce, isEmpty } from 'lodash'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

import SearchIcon from '@material-ui/icons/Search'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {
  Grid,
  Typography,
  Box,
  TextField,
  InputAdornment
} from '@material-ui/core';

import { useLazyQuery, gql } from '@apollo/client'
import { GET_CATEGORY_BY_NAME } from '@/services/inventoryService'

import images from '@/assets/images';
import { Colors } from '@/theme';
import useStyles from './styles';


const CategorySearchInput = ({ onSelectCategory, ...restProps }) => {
  const classes = useStyles();
  const { t } = useTranslation()

  const [categories, setCategories] = useState([])

  const [getCategoriesByName, { loading: isLoadingCategories }] = useLazyQuery(gql`${GET_CATEGORY_BY_NAME}`, {
    onCompleted: (data) => {
      if (isEmpty(data.categories)) {
        setCategories([{ empty: true }])
      } else {
        setCategories(data.categories)
      }
    },
    onError: () => {

    },
    fetchPolicy: 'cache-and-network'
  })

  const searchCategories = (input) => {
    setCategories([])
    if (input) {
      getCategoriesByName({
        variables: {
          filter: {
            count: true,
            page: 1,
            limit: 10,
            name: `%${input.toLowerCase()}%`,
          }
        },
      })
    }
  }

  return (
    <Autocomplete
      id="product-search-input"
      freeSolo
      options={categories}
      renderInput={(params) => (
        <Box style={{ position: 'relative' }}>
          <TextField
            {...params}
            {...restProps}
            placeholder={t('categories.enter_category_name')}
            className={classes.searchInput}
          />
          <SearchIcon
            className={classes.searchIcon}
            fontSize='small'
          />
        </Box>
      )}
      getOptionLabel={(option) => option?.name || ''}
      renderOption={(option, { inputValue }) => {
        if (option?.empty) {
          return (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              style={{ paddingTop: 20, paddingBottom: 20 }}
            >
              <Grid item>
                <img src={images.noProducts} width={90} height={90} />
              </Grid>
              <Grid item>
                <Typography className={classes.noMatchingText}>
                  {t('categories.no_categories_found')}
                </Typography>
              </Grid>
            </Grid>
          )
        } else {
          const nameMatches = match(option.name, inputValue);
          const nameParts = parse(option.name, nameMatches);

          return (
            <Box paddingX={2} paddingY={3}>
              <Box>
                {nameParts.map((part, index) => (
                  <span
                    key={index}
                    style={{
                      fontWeight: part.highlight ? 600 : 400,
                    }}
                  >
                    {part.text}
                  </span>
                ))}
              </Box>
            </Box>
          )
        }
      }}
      onInputChange={debounce((e, newInputValue) => searchCategories(newInputValue), 1000)}
      filterOptions={(x) => x}
      loading={isLoadingCategories}
      loadingText={t('workboard.product_intelligence.loading_products')}
      onChange={(event, category) => {
        if (category?.id) {
          onSelectCategory(category)
        } else {
          return
        }
      }}
    />
  )
}

export default CategorySearchInput